'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { ContentInfo } from '@src/components/a11y/ContentInfo/ContentInfo';
export function ContentInfoLandmark(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ContentInfo>{children}</ContentInfo>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}